import { i18n } from "@/i18n";
import { DateFormat, formatDate } from "@/util/date-util";
import { getCurrentDate } from "@/util/date-util";

export function getCsvFileName(): string {
  let filename: string = i18n.t(
    "components.search.search.csvFileNamePrefix"
  ) as string;
  filename += formatDate(DateFormat.yyyysMMsdd, getCurrentDate()) + ".csv";

  return filename;
}
